import React from "react";
import "./solid-button.css";
import styled from "styled-components";

const Button = styled.button`
  width: ${(props) => props.width};
  height: 60px;
  border-radius: 5px;
  color: #f5f5f5;
  font-weight: 500;
  font-size: 20px;
  line-height: 22px;
  /* or 110% */
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
  background-color: #be0303;
  border: none;
  cursor: pointer;
`;

function SolidButton({ text, width, onclick }) {
  const defaultText = text !== undefined ? text : "Submit";
  return (
    <Button className="btn-solid-container" width={width} onClick={onclick}>
      {defaultText}
    </Button>
  );
}

export default SolidButton;
